import React, { FunctionComponent } from 'react'
import OverviewContainer from './ByOverview'

const OverviewReportReport: FunctionComponent = () => {
  return <OverviewContainer />
}

export default OverviewReportReport
